export const SITE_SEARCH_URL = '/site-search?searchTerm=';
export const SEARCH_FEED = 'searchfeed';
export const MODAL_OPEN = 'modal-open';
export const NO_SCROLL = 'no-scroll';
